/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import {createSelector} from 'reselect';
import {createDeepEqualSelector} from './SelectorUtils';

export const selectLoggedInUser = ({login: {user}}: any) => user;
export const selectUserAccount  = state => selectLoggedInUser(state)?.account;
const selectSystemOfUnits       = ({login: {user}}) => user?.systemOfUnits;

const selectPermission                 = ({initialization: {permissions}}) => permissions;
const selectPostInitializationComplete = ({initialization}) => initialization.postInitializationComplete;

export const loggedInUserSelector =
  createDeepEqualSelector([selectLoggedInUser], (loggedInUser) => loggedInUser);

export const userAccountSelector =
  createDeepEqualSelector(selectUserAccount, (userAccount) => userAccount);

export const permissionSelectedSelector = createDeepEqualSelector(
  [selectPermission], (permissions) => permissions
);

export const postInitializationCompleteSelector = createSelector(selectPostInitializationComplete,
  (postInitializationComplete: boolean): boolean => postInitializationComplete
);

export const systemOfUnitsSelector = createDeepEqualSelector(selectSystemOfUnits,
  (systemOfUnits: any): any => systemOfUnits
);
